module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/detailed-results/detailed-results.component.css
// module id = ./src/app/detailed-results/detailed-results.component.css
// module chunks = main